namespace TabAurous.ProductDevelopment {
    export interface DesignRequestForm {
        TransItemId: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.ServiceLookupEditor;
        CategoryId: CommonCategoryLookup;
        CategoryCode: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        Iteration: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        DesignName: Serenity.StringEditor;
        LedgerName: Serenity.StringEditor;
        CustomerPrefix: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ProductId: Serenity.StringEditor;
        MetalId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        SKU: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        ProductName: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        HasBom: Serenity.BooleanEditor;
        ZProofId: Serenity.StringEditor;
        Attribute: Serenity.StringEditor;
        CalcOnId: Serenity.LookupEditor;
        CalcUnitId: Serenity.LookupEditor;
        MappingId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        IsSmartStone: Serenity.BooleanEditor;
        StoneSizeId: StoneSizeLookup;
        IsSubmitted: Serenity.BooleanEditor;
        Pieces: Serenity.IntegerEditor;
        ExportPieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        PureWeight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        Remarks: Serenity.StringEditor;
        BOMDetails: DesignRequestBOMEditor;
        Remark: Serenity.HtmlContentEditor;
        SpecialRemark: Serenity.HtmlContentEditor;
        UserDescription: Serenity.StringEditor;
        ProductSizeName: Serenity.StringEditor;
        MetalColorName: Serenity.StringEditor;
        KaratName: Serenity.StringEditor;
        Code: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
        ImageName: Serenity.ImageUploadEditor;
        Image1: Serenity.ImageUploadEditor;
        Image2: Serenity.ImageUploadEditor;
        Image3: Serenity.ImageUploadEditor;
    }

    export class DesignRequestForm extends Serenity.PrefixedContext {
        static formKey = 'ProductDevelopment.DesignRequest';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DesignRequestForm.init)  {
                DesignRequestForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = s.LookupEditor;
                var w5 = s.BooleanEditor;
                var w6 = CommonProductSizeLookup;
                var w7 = StoneSizeLookup;
                var w8 = s.DecimalEditor;
                var w9 = DesignRequestBOMEditor;
                var w10 = s.HtmlContentEditor;
                var w11 = s.ImageUploadEditor;

                Q.initFormType(DesignRequestForm, [
                    'TransItemId', w0,
                    'VoucherTypeId', w1,
                    'PartyId', w2,
                    'CategoryId', w3,
                    'CategoryCode', w0,
                    'RefNo', w0,
                    'Iteration', w0,
                    'DesignCode', w0,
                    'DesignId', w0,
                    'DesignName', w0,
                    'LedgerName', w0,
                    'CustomerPrefix', w0,
                    'ProductCode', w0,
                    'ProductId', w0,
                    'MetalId', w4,
                    'KaratId', w4,
                    'MetalColorId', w4,
                    'SKU', w0,
                    'ItemTypeId', w1,
                    'BagNo', w0,
                    'ProductTypeId', w4,
                    'ProductName', w0,
                    'AttributeId', w0,
                    'HasBom', w5,
                    'ZProofId', w0,
                    'Attribute', w0,
                    'CalcOnId', w4,
                    'CalcUnitId', w4,
                    'MappingId', w4,
                    'ProductSizeId', w6,
                    'IsSmartStone', w5,
                    'StoneSizeId', w7,
                    'IsSubmitted', w5,
                    'Pieces', w1,
                    'ExportPieces', w1,
                    'Weight', w8,
                    'PureWeight', w8,
                    'NetWeight', w8,
                    'Remarks', w0,
                    'BOMDetails', w9,
                    'Remark', w10,
                    'SpecialRemark', w10,
                    'UserDescription', w0,
                    'ProductSizeName', w0,
                    'MetalColorName', w0,
                    'KaratName', w0,
                    'Code', w0,
                    'CompanyId', w1,
                    'ImageName', w11,
                    'Image1', w11,
                    'Image2', w11,
                    'Image3', w11
                ]);
            }
        }
    }
}
